import { Injectable } from '@angular/core';
import { TipoPeriodo } from '../../../models/dashboard/periodo-filtro.model';

/**
 * Estado persistido do filtro de periodo de uma tela.
 *
 * v1: guarda o suficiente para restaurar o ultimo periodo escolhido.
 * - Se `tipo` for um preset relativo (today/thisMonth/last30/...), as datas
 *   sao RECOMPUTADAS no load (para nao restaurar datas velhas).
 * - Se for manual ('custom' / aba "Periodos"), as datas SALVAS sao usadas.
 */
export interface PeriodoFiltroEstado {
  tipo: TipoPeriodo | number;
  filterType: 'periods' | 'monthDay';
  dataInicio: string;
  dataFim: string;
  texto: string;
}

/**
 * Persistencia (por-tela) do ultimo filtro de periodo usado, em `localStorage`.
 *
 * As chaves sao namespaceadas como `periodo-filtro:<persistKey>`. Tudo e
 * protegido por try/catch porque o `localStorage` pode estar indisponivel
 * (modo privado, SSR, cota cheia) — nesses casos o componente cai no fallback.
 */
@Injectable({ providedIn: 'root' })
export class PeriodoFiltroPersistenciaService {

  private readonly prefixo = 'periodo-filtro:';

  salvar(persistKey: string, estado: PeriodoFiltroEstado): void {
    try {
      if (typeof window === 'undefined' || !window.localStorage) {
        return;
      }
      window.localStorage.setItem(this.prefixo + persistKey, JSON.stringify(estado));
    } catch {
      // Storage indisponivel ou cota cheia: ignora (fallback assume).
    }
  }

  carregar(persistKey: string): PeriodoFiltroEstado | null {
    try {
      if (typeof window === 'undefined' || !window.localStorage) {
        return null;
      }
      const raw = window.localStorage.getItem(this.prefixo + persistKey);
      if (!raw) {
        return null;
      }
      const estado = JSON.parse(raw) as PeriodoFiltroEstado;
      // Validacao minima: precisa ter ao menos tipo e as datas resolvidas.
      if (!estado || estado.tipo === undefined || estado.tipo === null) {
        return null;
      }
      return estado;
    } catch {
      // JSON invalido / storage indisponivel: ignora e usa fallback.
      return null;
    }
  }
}
